import { render, staticRenderFns } from "./BeforeAfterMessages.vue?vue&type=template&id=3b562735&"
import script from "./BeforeAfterMessages.vue?vue&type=script&lang=ts&"
export * from "./BeforeAfterMessages.vue?vue&type=script&lang=ts&"
import style0 from "./BeforeAfterMessages.vue?vue&type=style&index=0&id=3b562735&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports